// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
// import 'vant/lib/vant-css/index.css'
Vue.use(Vant)

import '../static/css/font.css'
import '../static/css/style.css'
import '../static/css/wapbasic.css'
import '../static/css/swiper.min.css'

import {get, post} from "./api/http"
Vue.prototype.$get = get;
Vue.prototype.$post = post;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js